import React, { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { API, imgUrl } from "../lib/api";

export default function SplashScreen({ onDone }) {
  const [leaving, setLeaving] = useState(false);
  const [logo, setLogo] = useState(`${process.env.PUBLIC_URL || ""}/logo.png`);

  useEffect(() => {
    fetch(`${API}/config`)
      .then((r) => r.json())
      .then((d) => { if (d?.splash_logo) setLogo(imgUrl(d.splash_logo)); })
      .catch(() => {});
    const t1 = setTimeout(() => setLeaving(true), 1000);
    const t2 = setTimeout(() => onDone && onDone(), 1300);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className={`rl-splash ${leaving ? "rl-splash-out" : ""}`}
      data-testid="splash-screen"
    >
      <div className="rl-splash-glow" />
      <div className="rl-coin-rain" aria-hidden="true" data-testid="splash-coins">
        {Array.from({ length: 18 }, (_, i) => (
          <span key={i} className="rl-rain-coin" style={{ left: `${(i * 53) % 100}%`, animationDelay: `${(i % 6) * 0.22 + (i % 3) * 0.07}s`, animationDuration: `${1.6 + (i % 4) * 0.3}s`, fontSize: `${16 + (i % 3) * 6}px` }}>🪙</span>
        ))}
      </div>
      <div className="rl-splash-inner">
        <div className="rl-logo-ring" />
        <div className={`rl-splash-crown ${logo ? "rl-splash-crown-img" : ""}`} data-testid="splash-crown">
          {logo ? (
            <img src={logo} alt="ROYAL LAKSHMI" className="w-full h-full object-cover rounded-[26px]" data-testid="splash-logo-img" />
          ) : (
            <Crown className="w-14 h-14" strokeWidth={2.2} />
          )}
        </div>
        <h1 className="rl-splash-title" data-testid="splash-title">ROYAL LAKSHMI</h1>
        <p className="rl-splash-tag">PREMIUM PLAY</p>
        <div className="rl-splash-bar"><span /></div>
      </div>
    </div>
  );
}
